/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ main: NonNullable<unknown>, foreign: NonNullable<unknown> }} Snackbar_Mappingremovederror2Inputs */

const en_snackbar_mappingremovederror2 = /** @type {(inputs: Snackbar_Mappingremovederror2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to remove ${i?.main} from ${i?.foreign}.`)
};

const de_snackbar_mappingremovederror2 = /** @type {(inputs: Snackbar_Mappingremovederror2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Entfernen von ${i?.main} von ${i?.foreign}.`)
};

/**
* | output |
* | --- |
* | "Failed to remove {main} from {foreign}." |
*
* @param {Snackbar_Mappingremovederror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const snackbar_mappingremovederror2 = /** @type {((inputs: Snackbar_Mappingremovederror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snackbar_Mappingremovederror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_snackbar_mappingremovederror2(inputs)
	return de_snackbar_mappingremovederror2(inputs)
});
export { snackbar_mappingremovederror2 as "snackbar_mappingRemovedError" }